import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNotification } from '../../../hooks/useNotification';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDataAuth } from '../../../hooks/useDataAuth';
import { useForm } from '../../../hooks/useForm';
import { useTranslation } from "react-i18next";
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import moment from 'moment';
import { DividerGradient } from '../../../components/dividerGradient/DividerGradient';
import { DialogSelectCompany } from '../../../components/dialogs/DialogSelectCompany';
import { ActionButtons } from '../../../components/others/ActionButtons';
import { SupplierForm } from '../../../components/invoice/SupplierForm';
import { LocationForm } from '../../../components/invoice/LocationForm';
import { ProductsForm } from '../../../components/invoice/ProductsForm';
import LoadingOverlay from '../../../components/others/LoadingOverlay';
import { OrderForm } from '../components/OrderForm';
import { ClientForm } from '../../../components/invoice/ClientForm';

import { insert, getCompanies, update, fetchOrder, fetchProductsOrder } from "../../../services/order.service";

const model = {
    documentId: 'Asignado por el sistema',
    id_company: '',
    supplier: '',
    supplier_id: '',
    supplier_digit: '',
    id_supplier_document: '',
    supplier_tax_id: '',
    supplier_tax_scheme_id: '',
    supplier_tax_level_code: [],
    receiver: '',
    receiver_id: '',
    receiver_digit: '',
    receiver_tax_id: '',
    id_receiver_document: '',
    receiver_tax_scheme_id: '',
    receiver_tax_level_code: [],
    receiver_country: '',
    receiver_state: '',
    receiver_city: '',
    receiver_phone: '',
    reciever_extension: '',
    receiver_address: '',
    receiver_email: '',
    receiver_postalCode: '',
    products: [],
    currency: 'COP',
    approver: '',
    id_approver: '',
    id_warehouse: '',
    group: '',
    id_group: '',
    observations: '',
    created: '',
    updated: '',
    issue_date: moment(new Date()).format('YYYY/MM/DD'),
    payment_due_date: moment(new Date()).format('YYYY/MM/DD'),
    expedition_date: moment(new Date()).format('YYYY/MM/DD')
}
export const LayoutOrder = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [sendNotification] = useNotification();
    const [{ userSession }] = useDataAuth();
    const { t } = useTranslation();
    const productsFormRef = useRef();
    const invoiceRef = useRef();
    const supplierRef = useRef();
    const clientmRef = useRef();
    const locationRef = useRef();

    const [invoiceData, handleInputChange, handleDirectInputChange, setAllInfo] = useForm(model);
    const [loading, setLoading] = useState(false);
    const [edit, setEdit] = useState(false);
    const [isView, setIsView] = useState(false);
    const [companies, setCompanies] = useState([]);
    const [openDialogCompany, setOpenDialogCompany] = useState(false);    

    const fetchInvoiceData = useCallback(async (idInvoice) => {
        try {
          const [InvoiceRes, productsRes] = await Promise.all([
            fetchOrder(idInvoice, userSession.token),
            fetchProductsOrder(idInvoice, userSession.token)
          ]);
          if (InvoiceRes.status === 200 && productsRes.status === 200) {
            if (InvoiceRes?.data?.[0]){
                const order = {
                    ...InvoiceRes.data[0],
                    supplier_tax_level_code: InvoiceRes.data[0].supplier_tax_level_code
                        ? InvoiceRes.data[0].supplier_tax_level_code.split(',')
                        : [],
                    receiver_tax_level_code: InvoiceRes.data[0].receiver_tax_level_code
                        ? InvoiceRes.data[0].receiver_tax_level_code.split(',')
                        : [],
                    payment_due_date: moment(
                        InvoiceRes.data[0].payment_due_date.split('T')[0],
                        'YYYY-MM-DD'
                    ).toDate(),
                    products: productsRes.data || []
                };
                handleDirectInputChange("id_company" ,order.id_company)
                setAllInfo(order);
                setEdit(true);
                setLoading(false);
            }
            else
                console.error("Error uploading data")
          }
        } catch (error) {
            console.error("Error fetching opportunity data:", error);
        }
      }, [userSession.token]);

    useEffect(() => {
        if (location.state && location.state.config) {
            const { data } = location.state.config || {};
            if (data?.work_flow === 'FLOW_PROCESS-VIEW_ORDER_REFERENCE') {
                setIsView(true);
            }

            if (data?.id) {
                setEdit(true);
                setLoading(true);
                setOpenDialogCompany(false);
                fetchInvoiceData(data.id)
            } else {
                const fetchData = async () => {
                    try {
                        setLoading(true);
                        const response = await getCompanies('23', userSession.token);
                        setCompanies(response.data || []);
                        if (response.data && response.data.length === 1) {
                            const dto = response.data[0];
                            setSupplierData(dto);
                            setOpenDialogCompany(false);
                        }
                        else
                            setOpenDialogCompany(true);
                    } catch (err) {
                        console.log(err.message);
                    } finally {
                        setLoading(false);
                    }
                };
                fetchData();
            }
        }
    }, [location.state, userSession.token, fetchInvoiceData]);

    const handleSubmit = async () => {
        const isCreatingProduct = !productsFormRef.current?.getData().some(product => product.isCreated);
        const validations = [
            supplierRef.current?.validForm(),
            clientmRef.current?.validForm(),
            locationRef.current?.validForm(),
            invoiceRef.current?.validForm(),
            productsFormRef.current?.validForm(),
            isCreatingProduct
        ];
        const isValidForm = validations.every(Boolean);
        if (isValidForm) {
            const json = {
                ...invoiceData,
                supplier_tax_level_code: invoiceData.supplier_tax_level_code.join(','),
                receiver_tax_level_code: invoiceData.receiver_tax_level_code.join(','),
            };
            const data = JSON.stringify(json);
            // console.log("invoiceData", JSON.stringify(data, null, 4))
            if (edit){
                await update(data, userSession.token);
            }else{
                await insert(userSession.token, data);
            }
            sendNotification({
                msg: 'Datos del documento enviados',
                variant: 'success',
            });
            Cancel();
        }
        else {
            if(!isCreatingProduct){
                sendNotification({ msg: t('validation.unsavedChanges'), variant: 'error'});
                return;
            }
            sendNotification({ msg: t('validation.requiredFieldsMissing'), variant: 'error' });
            return;
        }
    };

    const Cancel = () => {
        setOpenDialogCompany(false);
        navigate(-1);
    }

    const handleConfirmAction = useCallback(async (dto) => {
        setSupplierData(dto);
        setOpenDialogCompany(false);
    }, []);

    const setSupplierData = (dto) => {
        const oblig = dto?.supplier_tax_level_code?.split(",") || [];
        handleDirectInputChange('supplier', dto.name || '');
        handleDirectInputChange('id_company', dto.id_company || '');
        handleDirectInputChange('supplier_id', dto.id_number || '');
        handleDirectInputChange('supplier_digit', dto.supplier_digit || '');
        handleDirectInputChange('id_supplier_document', dto.supplier_additional_account_id || '');
        handleDirectInputChange('supplier_tax_id', dto.supplier_tax_id || '');
        handleDirectInputChange('supplier_tax_scheme_id', dto.supplier_tax_scheme || '');
        handleDirectInputChange('supplier_tax_level_code', oblig || []);
    }
    return (
        <>
            <Box sx={{ width: '90%', mx: 'auto' }}>
                <Typography variant="h4" gutterBottom>
                    {isView 
                    ? t('crm.orderReferenceTitle') 
                    : `${edit ? t('edit') : t('create')} ${t('crm.orderReferenceTitle')}`}
                </Typography>
                <Card sx={{mb: 3}}>
                    <CardContent>
                        <Typography variant="h6" gutterBottom>{t('suppliers.supplierInofo')}</Typography>
                        <SupplierForm
                            ref={supplierRef}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={invoiceData || {}}
                            isEdit={edit}
                        />

                        <DividerGradient/>

                        <Typography variant="h6" gutterBottom>{t('client.providerInfo')}</Typography>
                        <ClientForm
                            ref={clientmRef}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={invoiceData || {}}
                        />

                        <DividerGradient/>

                        <Typography variant="h6" gutterBottom>{t('client.locationTitle')}</Typography>
                        <LocationForm
                            ref={locationRef}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={invoiceData || {}}
                            documentId={invoiceData?.receiver_id}
                            isEdit={edit}
                        />

                        <DividerGradient/>

                        <Typography variant="h6" gutterBottom>{t('crm.orderReferennceInfo')}</Typography>
                        <OrderForm
                            ref={invoiceRef}
                            handleInputChange={handleInputChange}
                            handleDirectInputChange={handleDirectInputChange}
                            dto={invoiceData || {}}
                        />

                        <DividerGradient/>

                        <Typography variant="h6" gutterBottom>{t('crm.products.title')}</Typography>
                        <ProductsForm
                            ref={productsFormRef}
                            dto={invoiceData}
                            observations={invoiceData?.observations || ''}
                            isOpportunity={false}
                            edit={edit}
                            isView={isView}
                            handleDirectInputChange={handleDirectInputChange}
                            handleInputChange={handleInputChange}
                        />

                        <ActionButtons
                            onCancel={Cancel}
                            onSubmit={handleSubmit}
                            submitLabel={t('save')}
                            disabledSubmit={isView}
                        />
                    </CardContent>
                </Card>
            </Box>
            
            {loading && <LoadingOverlay isOpen={loading} />}
            {openDialogCompany && (
                <DialogSelectCompany
                    openDialogConfirm={openDialogCompany}
                    handleCancelConfirm={Cancel}
                    handleConfirmAction={handleConfirmAction}
                    data={companies}
                />
            )}
        </>
    );
};